export const getArrayOfRolesFromString = (roleString) => {
  if (!roleString.length)
    return [];

  return roleString.split(',');
}

export const getStringOfRolesFromArray = (roleArray) => {
  return roleArray.reduce((prev, r) => prev + `${r},`, '').slice(0, -1);
}